export default __webpack_public_path__ + "static/media/gamePlayBg.e1af5aa5.jpg";